import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoadingStateService } from './loading-state.service';
import { RecordWriteTrackerService } from './record-write-tracker.service';

// HV-05: covers the generic record-mutation endpoints used app-wide (edit-form save,
// stacking-plan floor/elevator saves, bulk company/contact updates, attachments, ...),
// which all go through /write or /multiwrite regardless of the calling module.
const WRITE_ENDPOINT_PATTERN = /\/(write|multiwrite)(\/|\?|$)/;
const MUTATING_METHODS = new Set(['PUT', 'POST', 'PATCH', 'DELETE']);

@Injectable()
export class LoadingHttpInterceptor implements HttpInterceptor {
  constructor(
    private loading: LoadingStateService,
    private writeTracker: RecordWriteTrackerService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loading.resolving();
    const isWriteRequest = MUTATING_METHODS.has(request.method) && WRITE_ENDPOINT_PATTERN.test(request.url);
    return next.handle(request).pipe(
      tap(event => {
        if (isWriteRequest && event instanceof HttpResponse && event.ok) {
          this.writeTracker.markWritten();
        }
      }),
      finalize(() => this.loading.resolved())
    );
  }
}
